import React, { useEffect } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  lockZoom,
  setCompareMode,
  setLanguageLock,
  unlockZoom,
} from '../../../../store/ui/ui.slice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { uiSelectors } from '../../../../store/ui/ui.selectors';
import { CheckboxWithLabel } from '../../../StaticComponents/CheckboxWithLabel';

import './CompareOptionsBar.scss';

import { COMPARE_MODE, CompareOptionsBarProps } from './CompareOptionsBar.types';
import { useScrollSync } from '../../../Documents/DocumentViewModal/ScrollSyncContext';

export const CompareOptionsBar: React.FC<CompareOptionsBarProps> = ({
  disabled = false,
  isDocumentMode = false,
}) => {
  const dispatch = useAppDispatch();
  const mode = useAppSelector(uiSelectors.selectCompareMode);
  const isLanguageLocked = useAppSelector(uiSelectors.selectLockLanguage);
  const zoomLocked = useAppSelector(uiSelectors.selectZoomLocked);

  const handleModeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setCompareMode((event.target as HTMLInputElement).value as COMPARE_MODE));
  };

  const handleLanguageLockChange = (checked: boolean) => {
    dispatch(setLanguageLock(checked));
  };

  const { isScrollSyncEnabled, setIsScrollSyncEnabled } = useScrollSync();

  const handleZoomLockChange = (checked: boolean) => {
    dispatch(checked ? lockZoom() : unlockZoom());
  };

  useEffect(() => {
    return () => {
      dispatch(unlockZoom());
    };
  }, [dispatch]);

  return !disabled ? (
    <div className='compare-options-bar'>
      <RadioGroup
        row
        aria-labelledby='compare-options-label'
        name='compare-options-group'
        onChange={handleModeChange}
        value={mode}
      >
        <FormControlLabel
          value={COMPARE_MODE.SHOW_ORIGINAL}
          control={<Radio />}
          label='Show original'
        />
        <FormControlLabel
          value={COMPARE_MODE.SHOW_DIFFERENCES}
          control={<Radio />}
          label='Show differences'
        />
        <FormControlLabel
          value={COMPARE_MODE.SHOW_SIMILARITIES}
          control={<Radio />}
          label='Show similarities'
        />
        {!isDocumentMode ? (
          <FormControlLabel
            value={COMPARE_MODE.SHOW_REPLACEMENTS}
            control={<Radio />}
            label='Show replacements'
          />
        ) : null}
      </RadioGroup>
      <div>
        <CheckboxWithLabel
          checked={isLanguageLocked}
          onChange={(_, checked) => handleLanguageLockChange(checked)}
          label='Lock tab'
        />
        <CheckboxWithLabel
          checked={isScrollSyncEnabled}
          onChange={(_, checked) => setIsScrollSyncEnabled(checked)}
          label='Lock scroll'
        />
        <CheckboxWithLabel
          checked={zoomLocked}
          onChange={(_, checked) => handleZoomLockChange(checked)}
          label='Lock zoom'
        />
      </div>
    </div>
  ) : null;
};
